
$('.eiglishFont').css({'cssText': 'font-size: 14px !important;line-height:59px!important;'})
module.exports = { 
  //头部尾部 公共
  menu : { 
    mobile:"Mobile terminal",
    login:"Login",
    register:"Register",
    zh:"English",
    english:"Chinese",
    weather:'Weather',
    home:"Home",
    intoPark:'Into Park',
    inPark:'In Park',
    hotPark: 'Hot Park',
    serverPark: 'Server Park',
    homeePark: 'Home e Park',
    garden: 'Garden',
    center1: 'Business center',
    center2: 'Personal center',
    center3: 'Log out',
    link:'Friendly link',
    link2: 'Municipal human resources and social security bureau',
    link3:'Municipal administration network',
    serviceTel: 'Service tel',
    feedback: 'Feedback',
    time: 'Working hours: 9:00-18:00 (Monday to Friday)',
    address: 'Address: Block B, Heda Center, No. 179, Tailiu Road, North District, Qingdao',
    server: 'Service reservation',
    dock2: 'Supply and demand dock',
    recruit2: 'Job hunting',
    help: 'Pettitte help',
    campus: 'Campus BBS',
    submit:'submit',
    replayT: 'detail',
    userinfo3: 'No account? Go to the registration',
    userinfo4: 'Confirm',
    userinfo5: 'code',
    userinfo6: 'Real name',
    userinfo7: 'Id number',
    userinfo8: 'email',
    userinfo9: 'cell-phone number',
    id: 'Have an account? Go to the login',
    agree: 'I have read and accepted',
    agree2: 'user agreement',
    forgetpwd: 'Forget password',
    careful:'Note: please send a copy of the business license to the industrial park office',
  }, 
  //首页和搜索页
  index:{ 
    onlineOffice:'Online Office',
    quickEntry:'Quick Entry',
    VR: 'VR park',
    watch : 'Watch',
    info :'PARK DYNAMICS',
    serverPark: 'PARK SERVICE',
    serach: 'Serach',
    recruit: 'RECRUITMENT INFORMATION',
    dock: 'DOCK INFORMATION',
    settled : 'SETTLED ENTERPRISE',
    weather:'Weather forecast',
    happy: 'Happy parking',
    bus : 'Bus information',
    flight: 'Flight information',
    train :'Train information',
    comment: 'Public comment',
    baidu : 'Baidu map',
    surround: 'Surrounding',
    scan: 'Official address',
    suggest:'Ideas box',
    qust:'Naire',
    qust2:'Questio list',
    null1:'No recruitment information',
    null2:'No docking information',
    null3:'No entry Enterprises',
    null4:'No search results',
  },
  park:{
    abstract: 'Park profile',
    law: 'Laws and regulations',
    down: 'Downloads',
    down2: 'download',
    null:'No data',
    source:'source',
    date:'date',
    null2:'No details',
  },
  enterPark:{
    support: 'Support policy',
    conditions :'In condition of',
    assort: 'Supporting services',
    application: 'In the application',
    company: 'Park enterprises',
    companyInfo : "Basic information of the enterprise " ,
    companyName: 'Company Name',
    companyRegistered : 'Business registration place:',
    representative : 'Legal representative' , 
    linkman: 'Contact',  
    linkduty: 'Contact position',  
    linkTel: 'Contact number', 
    linkEmail: 'Contact mailbox ',   
    direction1: 'The main business direction of the company',
    direction2: 'Business status',
    direction3 : 'The turnover of the company (10,000)',
    direction4: 'Revenue',
    direction5: 'Tax',
    direction6: 'Registration name of the company',
    direction7: 'Registered capital',
    direction8: 'Main business and scale (main business, good at/innovative direction, business performance, industry status, over 200 words)',
    direction9: 'Park company expects main business and scale',
    direction10: 'Park company expects organizational structure and staff size',
    direction11: 'Company resources and features',
    direction12: 'Existing customer situation (if no, please indicate the reason)',
    direction13: 'Customer status of the city customers or potential customers in this city',
    direction14: 'Business compliance description',
    direction15: 'Is it convenient for field trips',
    direction16: 'Application for entry',
    direction17: 'Application area (building area square meters)',
    direction18: 'Other comments on the application for entry',
    business: 'Format',
    floor: 'Floor',
  } ,
  //园区热点
  hotspot:{
    hotPark2: 'Park dynamics',
    hotPark3: 'Announcement',
    hotPark4: 'Upcoming Events',
    hotPark5: 'Industry information',
    hotPark6:'Detail',
  },
  //园区服务
  service:{
    serverPark2: 'Qingdao human resources exchange association',
    serverPark3: 'Research institutions',
    serverPark4: 'Industrial fund',
    serverPark5: 'Product release',
    serverPark6: 'Innovation declaration',
    serverPark7: 'Industry association',    
  },
  //园区党建
  build:{
    garden2: 'Party committee introduction',
    garden3: 'Party member style',
    garden4: 'Party member station',
    garden5: 'Party member activity',
  },
  //智慧E家
  wisdom:{
    learn: 'Online learning',
    bookInfo1: 'Please fill news',
    bookInfo2: 'Application unit',
    bookInfo3: 'Applicant',
    bookInfo4: 'Phone number',
    bookInfo5: 'Meeting room',
    bookInfo6: 'Number',
    bookInfo7: 'Usage time',
    bookInfo8: 'to',
    bookInfo9: 'Open ladder time (up to 2 hours in the morning, noon)',
    bookInfo10: 'Conference content',
    bookInfo11: 'Other',
    bookInfo12:  'I have read and accept the user agreement',
    bookInfo13: '1. The user should apply to open the conference room at the park office half an hour before the start of the appointment time. After leaving, the table and chairs should be restored to their original positions. After the meeting, the staff of the park will confirm the acceptance and leave',
    bookInfo14: '2. Keep the room clean and hygienic. After the meeting, please clean the bottle, paper scraps, garbage, etc. If the unit fails to pass the two hygiene inspections, the application for the conference room of the unit will no longer be accepted',
    bookInfo15: '3. After the meeting, please shut down the electrical equipment, air conditioning and so on in time. If the equipment failure is caused during the use, please repair it in time. If there is any damage, please compensate according to the price. Otherwise, it will be deducted from the deposit according to the original price and will no longer accept the use application of the conference room of the unit',
    bookInfo16: '4. The conference room is only limited to the internal use of enterprises in the park, and the enterprises shall not lend it to other external enterprises under any pretext. Once found, the office of the administrative committee of the park shall have the right not to accept the application for the use of the conference room of the unit',
    bookInfo17: 'Appointment unit',
    bookInfo18: 'Appointment name',
    bookInfo19: 'Appointment call',
    bookInfo20: 'Appointment',
    bookInfo21: 'Number',
    express1: 'SF Express',
    express2: 'Jingdong Logistics',
    express3: 'Zhongtong Express',
    express4: 'Shentong Express',
    express5: 'Yuantong Express',
    express6: 'YunDa delivery',
    express7: 'Public comment',
    express8: 'US group takeaway',
    express9: 'Are you hungry',
    release: 'Release',
    roomdetail: 'Conference room details',
    bookL:'Order',


    enterprise1: 'Type of enterprise',
    enterprise2: 'Enterprise industry',
    enterprise3: 'Business scale',
    enterprise4: 'Contact name',
    enterprise5: 'Business Requirements Title',
    enterprise6: 'Specific business needs',
    enterprise7: 'Estimated purchase time',
    enterprise8: 'Estimated budget (unit: 10,000)',
    enterprise9: 'Whether to specify a supplier',
    enterprise10 : 'no',
    enterprise11 : 'yes',
    enterprise12 : 'Business service category',
    enterprise13 : 'Product name',
    enterprise14 : 'Product description',
    position1 : 'Recruitment position',
    position2 : 'Salary and benefits',
    position3 : 'Education',
    position4 : 'Work experience',
    position5 : 'Job description',
    position6 : 'Recruitment requirements',
    allQuet:"Answer all",
    allNote:"All messages",
    up : 'Topping',
    ask : 'Quiz',
    question : 'Question',
    Qdetails : 'Q&A details',
    recdetails: 'Recruitment details',
    title:'Title',
    content : 'Content',
    dockDetail : 'Butt details',
    upload : 'upload',
    download : 'download',
    loginafter : 'Reply to docking information',
    reply : 'reply',
    replay2 : 'reply',
  },
  center1:{
    corporateC1: 'Enterprise Information',
    corporateC2: 'Enterprise products',
    corporateC3: 'Enterprise honor',
    corporateC4: 'Business requirements',
    corporateC5: 'Business to supply',
    corporateC6: 'Enterprise recruitment',
    corporateC7: 'Message center',
    corporateC8: 'Enterprise related data',
    corporateC9: 'Change password',
    corporateC10: 'Improve enterprise information',
    corporateC11: 'Enterprise official network',
    corporateC12: 'Enterprise nature',
    corporateC13: 'Industry field',
    corporateC14: 'Company details',
    corporateC15: 'Upload',
    corporateC16: 'Preservation',
    fillin: 'Fill in product information',
    add: 'Add products',
    add2: 'Add honor',
    fillin2: 'Fill in honorary information',
    honur: 'Honorary title',
    needDetail: 'Demand for details',
    supplyDetail: 'Supply the details',
    no: 'No deliverer',
    no2:'No docking details',
    need:'Demand company',
    need2:'Supply company',
    delivery:'Delivery information',
    room:'Conference Room Facilities and Equipment',
    book:'Conference room reservation',
    book2:'Cooperative consultation Booking',
    book3:'Appointment in fitness class',
    various1: 'Tax data (10000)',
    various2:'The number of high-level talents introduced in the month',
    unit:'Revenue data (unit: 10,000)',
    honour1:'Acquire honors or patents',
    honour2:"Overview of Qingdao Company's Performance"
  },
  //个人中心
  center2:{
    vitae: 'Curriculum vitae',
    vertdetails: 'Resume details',
    resume1:'Name',
    resume2:'Sex',
    resume3:'Age',
    resume4:'Birthday',
    resume5:'Native place',
    resume6:'Contact number',
    resume7:'Mailbox',
    resume8:'Job intention',
    resume9:'Expected salary',
    resume10:'Educational background',
    resume11:'Internship experience',
    resume12:'Honors',
    resume13:'Qualification',
    resume14:'Professional skills',
    resume15:'Self evaluation',
    resume16:'Whether or not to open a resume',
    resume17:'Confirm revision',
  }
}


// WEBPACK FOOTER //
// ./src/assets/lang/en.js